import { parse, format } from 'date-fns'
import locale from 'date-fns/locale/fr'
import { upperFirst } from 'lodash'

const formatDate = (date, formatStr) => {
  let formatDate = date
  if (date) {
    formatDate = format(new Date(date), formatStr, { locale })
    formatDate = upperFirst(formatDate)
  }
  return formatDate
}

const parseDate = (date, format = 'yyyy-MM-dd') => {
  return parse(date, format, new Date())
}

export default {
  formatDate,
  parseDate
}
